import { Command } from 'commander'

import { clearAuthData } from '@/helpers'
import { output } from '@/helpers/std-out'

export const LogoutCommand = () => {
  const cmd = new Command('logout')

  cmd.description('Logout from scalar')
  cmd.action(async () => {
    clearAuthData()

    output.info().message('Successfully logged out.').print()
  })

  return cmd
}
